import { ChangeEventHandler } from 'react'
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material'

interface Props {
  label?: string
  value: boolean
  readonly?: boolean
  onChange?: ChangeEventHandler<HTMLInputElement>
  className?: string
}

export default function Checkbox({
  label,
  value,
  onChange,
  className = '',
  readonly = false,
}: Props) {
  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          checked={value}
          onChange={onChange}
          sx={{
            '.MuiSvgIcon-root': {
              color: 'primary',
            },
          }}
        />
      }
      sx={{
        m: 0,
        '.MuiFormControlLabel-label': {
          fontSize: 'small',
        },
      }}
      label={label}
      labelPlacement="start"
    />
  )
}
